import React, { useContext, useState, useEffect } from 'react';
import brand from '../../../branding';
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies

import JobListContext from '../../context/jobListContext';
import AppStateContext from "../../context/appStateContext";
import usePlannedFilterForm from "../../../hooks/usePlannedFilterForm";
import GetPMCallsFunction from "../../../functions/GetPMServiceCallsFunction";
import usePlannedSearch from "../../../hooks/usePlannedSearch";
import useSort from "../../../hooks/sortCard";
import useDetailsResize from "../../../hooks/useDetailsResize";
import APIHelper from "../../../hooks/useAPIHelper";
import filterHelper from '../../../hooks/useFilterHelper';
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";

import DropDown from '../../../components/dropdown';
import JobsList from "../../components/Lists/cardList";
import PlannedJobDetail from '../../components/jobDetailPlanned'
import PageHeader from '../../components/pageHeader';
import PageLayout from '../../components/pageLayout';
import SearchTab from '../../components/searchTabPm';
import ApiStatus, {CALLING,POPULATED,EMPTY,TIMEOUT} from "../../../components/apiStatus";

import HeaderImg from '../../../assets/images/headerImages/maintenance_header.png';

import {
  DropdownCtn,
  DropdownPosCtn,
  JobDetailsCtn,
  JobsListCtn,
  JobsTopCtn,
  PageCtn,
  PageHeaderText,
  SearchBox,
  SearchTabCtn,
} from './index.style';
import FiltersRm from "../../components/filtersRm";

const PlannedMaintenance: React.FC<any> = (): React.ReactElement => {
  const { openJobDetails, plannedJobList, filteredPlannedJobList, filtersPlanned, updatePlannedJobList, updateFilteredPlannedJobList,clearFilters, clearSelectedPlannedJob } = useContext(JobListContext);
  const { token, selectedCustomerId, siteLogo, setAppPageDetails } = useContext(AppStateContext);

  const { handleSearch } = usePlannedSearch(), { sortPlanned } = useSort(),  { filterDataByContract } = filterHelper(), getPMJobs = APIHelper();
  const { statusTabFilters, handleSubmit } = usePlannedFilterForm();
  const { handleBottom, renderedData, updateRenderedData } = useInfiniteScroll(plannedJobList, 'planned');

  const [ currentApiStatus, setCurrentApiStatus ] = useState<number>(CALLING);

  let detailsHeight = useDetailsResize(document.getElementById('details'),window.innerHeight - 245);

  const plannedJobsCallback = (data: [] | string) => {
   if(data == 'timeout') {
      setCurrentApiStatus(TIMEOUT);
      return;
    }

    if(data.length == 0) {
      setCurrentApiStatus(EMPTY);
      return;
    }

    updatePlannedJobList(filterDataByContract(data));
    updateRenderedData(filterDataByContract(data));

    if(statusTabFilters != '') {
      handleSubmit(null);
    }
    setCurrentApiStatus(POPULATED);
  };


  useEffect(() => {
    setAppPageDetails('plannedMaintenance');
    getPMJobs.run(GetPMCallsFunction, plannedJobsCallback, ['', token, selectedCustomerId]);
    return () => {
      clearFilters();
      clearSelectedPlannedJob();
    }
  },[]);

  useEffect(() => {
    updateRenderedData(filterDataByContract(filteredPlannedJobList));
  },[filteredPlannedJobList, filtersPlanned]);

  return (
    <PageLayout handleBottom={handleBottom} list>
      <PageHeader backgroundImg={(brand.heroImages && brand.heroImages['planned']) || brand.heroImage || siteLogo.background_image[3]['image']['url']}>
        <PageHeaderText>Planned Preventative Maintenance</PageHeaderText>
        <SearchBox type="text" placeholder="Search for a job name, building.." onChange={handleSearch}/>
      </PageHeader>
      <PageCtn>
        <SearchTabCtn>
          <SearchTab />
        </SearchTabCtn>
        <JobsListCtn>
          <JobsTopCtn>
            <DropdownPosCtn>
              <DropdownCtn>
                <span>Sort by</span>
                <div>
                  <DropDown defaultVal={1} optionList="plannedSort" onChange={(criteria) => sortPlanned(criteria)} />
                </div>
              </DropdownCtn>
            </DropdownPosCtn>
            <FiltersRm />
          </JobsTopCtn>
          <ApiStatus status={currentApiStatus} type="ring" >
            <JobsList itemList={renderedData} page="plannedMaintenance" type="planned"/>
          </ApiStatus>
        </JobsListCtn>
        <JobDetailsCtn active={openJobDetails} height={detailsHeight} id="details">
          {window.innerWidth > 768 && <PlannedJobDetail/>}
        </JobDetailsCtn>
      </PageCtn>
    </PageLayout>
  );
};

export default PlannedMaintenance;
